import { MemberGroups } from "shared-types";
import { getUserGroup } from "../services/authorization";

export function checkIsYp() {
  return getUserGroup() === MemberGroups.yPerformer;
}
